<div *ngIf="isFavorite == true">
  <img class="fav" src="assets/icons/svg/favorite-true.svg" title="{{ 'Page.ToolTips.FAVORITE' | translate }}">
</div>

<div *ngIf="isFavorite == false">
  <img class="fav" src="assets/icons/svg/favorite-false.svg" title="{{ 'Page.ToolTips.NOT_FAVORITE' | translate }}">
</div>
